/* eslint-disable @next/next/no-img-element, @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import objstr from 'obj-str';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';
import { useOverflowHidden } from '@/hooks/useOverflowHidden';
import { ITemplateData } from '@/services/template-data-service';
import { Srcset } from '@/components/Srcset/Srcset';
import styles from './SectorNavigation.module.scss';

export const SectorNavigation = ({ templateData }: { templateData: ITemplateData }) => {
  const { t } = useTranslation('header');
  const [isShown, setIsShown] = useState(false);
  useOverflowHidden(isShown);

  const toggleDropdown = () => {
    setIsShown(!isShown);
  };

  const dropDownStyles = objstr({
    [styles.sectorDropdown]: true,
    [styles.hidden]: !isShown,
    [styles.shown]: isShown
  });

  return (
    <div className="sector-navigation">
      <a role="button" className={styles.toggleButton} onClick={toggleDropdown}>
        {isShown && <span className="fa fa-chevron-up"></span>}
        {!isShown && <span className="fa fa-chevron-down"></span>}
        <span className="d-sm-none">{t('choose-your-bussiness-sector-short')}</span>
        <span className="d-none d-sm-inline">{t('choose-your-bussiness-sector')}</span>
      </a>

      <div className={dropDownStyles}>
        <div className={styles.sectors}>
          {templateData.sectorNavigation.map((sector) => (
            <div className={styles.sectorImage} data-theme={sector.key.toLowerCase()} key={sector.key}>
              <a title={sector.name} href={sector.link} className={styles.sectorLink}>
                <Srcset image={sector.image} />
                <span className={styles.sectorButton}>
                  {sector.name}
                  <FontAwesomeIcon icon={faArrowRightLong} className="ml-2" />
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
